import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface NavbarProps {
  currentPage?: 'dashboard' | 'lines' | 'users';
}

const Navbar: React.FC<NavbarProps> = ({ currentPage = 'dashboard' }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="bg-zinc-800 p-4 shadow-lg">
      <div className="flex justify-between items-center gap-4 flex-wrap">
        {/* Logo e Título */}
        <div className="flex items-center gap-4">
          <img
            src="/maurix-logo.png"
            alt="Maurix Logo"
            className="h-12"
            onError={(e) => {
              e.currentTarget.src =
                'https://placehold.co/80x80/cccccc/333333?text=Logo';
            }}
          />
          <div>
            <h1 className="text-2xl font-bold text-green-400">
              {currentPage === 'dashboard'
                ? '📊 Dashboard'
                : currentPage === 'lines'
                ? '📱 Gerenciar Linhas'
                : '👥 Gerenciar Usuários'}
            </h1>
            {user && <p className="text-xs text-gray-400">Usuário: {user.username}</p>}
          </div>
        </div>

        {/* Navegação e Ações */}
        <div className="flex items-center gap-2 flex-wrap">
          {/* Botões de Navegação */}
          {currentPage !== 'dashboard' && (
            <button
              onClick={() => navigate('/dashboard')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-3 rounded transition text-sm"
              title="Ir para Dashboard"
            >
              📊 Dashboard
            </button>
          )}
          {currentPage !== 'lines' && (
            <button
              onClick={() => navigate('/main')}
              className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-3 rounded transition text-sm"
              title="Ir para Gerenciar Linhas"
            >
              📱 Linhas
            </button>
          )}

          {/* Logout */}
          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-3 rounded transition text-sm"
            title="Fazer logout"
          >
            🚪 Sair
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
